'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'

export default function PinLoginPage() {
  const [pin, setPin] = useState('')
  const [error, setError] = useState(false)
  const router = useRouter()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(false)
    const res = await fetch('/api/pin-auth', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin }),
    })
    if (res.ok) {
      router.replace('/')
    } else {
      setError(true)
      setPin('')
    }
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 60px)',
      background: '#f9fafb',
    }}>
      <div style={{
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        padding: '40px',
        width: 320,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 20,
        boxShadow: '0 1px 3px rgba(0,0,0,0.07)',
      }}>
        <div style={{ fontSize: 13, color: '#6b7280', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
          AlpacaRelay
        </div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#111827', letterSpacing: '-0.02em' }}>
          Enter PIN
        </div>
        <form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <input
            type="password"
            value={pin}
            onChange={e => setPin(e.target.value)}
            maxLength={4}
            placeholder="••••"
            autoFocus
            style={{
              width: '100%',
              padding: '11px 14px',
              fontSize: 24,
              letterSpacing: '0.3em',
              textAlign: 'center',
              border: `1px solid ${error ? '#ef4444' : '#d1d5db'}`,
              borderRadius: 8,
              outline: 'none',
              fontFamily: 'inherit',
            }}
          />
          {error && (
            <p style={{ margin: 0, fontSize: 13, color: '#ef4444', textAlign: 'center' }}>
              Incorrect PIN
            </p>
          )}
          <button
            type="submit"
            style={{
              width: '100%',
              padding: 11,
              background: '#111827',
              color: '#fff',
              fontSize: 14,
              fontWeight: 600,
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  )
}
